import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHorns = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 82,
	height: 28,
	viewBox: "0 0 73 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group 18",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Vector 1",
			d: "M18 25C9.75823 18.2905 8.99377 10.3041 15.1694 0C7.37812 4.58187 -2.32816 13.0068 0.502472 25H18Z",
			fill: "white"
		}), /* @__PURE__ */ _jsx("path", {
			id: "Vector 2",
			d: "M55 25C63.2418 18.2905 64.0062 10.3041 57.8306 0C65.6219 4.58187 75.3282 13.0068 72.4975 25H55Z",
			fill: "white"
		})]
	})
});
export default SvgHorns;
